module.exports = __webpack_public_path__ + "img/d201211-4.39fb9400.jpg";